/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { createDialogRoute } from '@gh/common-shared';
import { EntityVersion, ID } from '@gh/common-shared-data';
import {
  AutocompleteLoadMoreEvent,
  DialogInput,
  NotificationService,
  WaitingService,
} from '@gh/core-ui';
import { JobDrawDetailsTabBusinessService } from '../../resources';
import { JobSalesPerson } from '../../resources/job.model';

@Component({
  standalone: false,
  selector: 'gh-component-job-reassign-dialog',
  templateUrl: 'job-details-reassign-dialog.component.html',
  styleUrls: ['job-details-reassign-dialog.component.scss'],
})
export class JobDetailsReassignDialogComponent implements OnInit, DialogInput<ComponentJobDetailsReassignConfig> {
  input: ComponentJobDetailsReassignConfig;

  jobId: ID;
  salesPersonId: ID;

  constructor(private dialogRef: MatDialogRef<any>,
              private businessService: JobDrawDetailsTabBusinessService,
              private waitingService: WaitingService,
              private notifications: NotificationService) {
  }

  ngOnInit(): void {
    this.jobId = this.input && this.input.jobId;
  }

  onCancel(): void {
    this.dialogRef.close(false);
  }

  loadSalesPersons(event: AutocompleteLoadMoreEvent): void {
    event.load(this.businessService.findSalesPersonsByName(event.query, this.input.salespersonId));
  }

  onSalesPersonSelected(salesPerson: JobSalesPerson): void {
    this.salesPersonId = salesPerson && salesPerson.userId;
  }

  onReassign(): void {
    this.businessService.reassign(this.jobId, this.input.version, this.salesPersonId).pipe(
      this.waitingService.operator<any>())
      .subscribe(
        () => this.dialogRef.close(true),
        this.notifications.processAll,
      );
  }
}

export const componentReassignJobDialogRoute = createDialogRoute({
  component: JobDetailsReassignDialogComponent,
  config: { autoFocus: false },
});

export interface ComponentJobDetailsReassignConfig {
  jobId: ID;
  version: EntityVersion;
  salespersonId?: ID;
}
